import { Dialog, DialogContent, DialogActions, Typography, Box } from '@mui/material';
import WarningAmberIcon from '@mui/icons-material/WarningAmber';
import { CustomButton } from '../';

const ConfirmationDialog = ({
  open,
  onClose,
  onConfirm,
  title = 'Confirmar acción',
  message,
  details,
  entityName = 'elemento',
  confirmText = 'Eliminar',
  cancelText = 'Cancelar',
  confirmVariant = 'danger',
  isLoading = false,
}) => {
  const defaultMessage = `¿Está seguro que quiere eliminar un elemento de ${entityName} de forma permanente?`;

  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth="sm"
      fullWidth
      sx={{
        '& .MuiDialog-paper': {
          borderRadius: '10px',
          boxShadow: '0 10px 40px rgba(0,0,0,0.15)',
        },
      }}
    >
      <DialogContent sx={{ textAlign: 'center', py: 4 }}>
        <Box sx={{ mb: 2 }}>
          <WarningAmberIcon
            sx={{
              fontSize: 60,
              color: 'warning.main',
              mb: 2,
            }}
          />
        </Box>

        <Typography variant="h6" sx={{ fontWeight: 'bold', mb: 2 }}>
          {title}
        </Typography>

        <Typography variant="body1" sx={{ color: 'text.secondary', mb: details ? 2 : 0 }}>
          {message || defaultMessage}
        </Typography>

        {details && (
          <Box
            sx={{
              mt: 3,
              p: 2,
              backgroundColor: 'grey.100',
              borderRadius: 1,
              textAlign: 'left',
            }}
          >
            {details}
          </Box>
        )}
      </DialogContent>

      <DialogActions sx={{ p: 3, justifyContent: 'center', gap: 2 }}>
        <CustomButton onClick={onClose} variant="warning" disabled={isLoading}>
          {cancelText}
        </CustomButton>

        <CustomButton onClick={onConfirm} variant={confirmVariant} isLoading={isLoading}>
          {confirmText}
        </CustomButton>
      </DialogActions>
    </Dialog>
  );
};

export default ConfirmationDialog;
